<template>
  <v-row>
    <v-col>
      <v-card class="mt-n3">
        <v-card-text style="height:350px; padding:6px 25px 16px">
          <v-row>
            <v-col
              xl="2"
              md="4"
              cols="12"
            >
              <v-row>
                <v-col class="d-flex align-center">
                  <h2 class="subtitle-1 mr-2">
                    <JiraIssueLink :issue="issue.key" />
                  </h2>
                  <v-chip
                    dark
                    color="green darken-1"
                    label
                    small
                  >
                    {{
                      issue.status
                    }}
                  </v-chip>
                </v-col>
              </v-row>
              <p
                class="font-weight-bold mb-2 "
                style="height:45px; overflow-y:auto;"
              >
                {{ issue.summary }}
              </p>
              <ul
                style="list-style: none;"
                class="pa-0"
              >
                <li class="mb-2">
                  <h3 class="body-2">
                    Автор:
                  </h3>
                  <span class="pl-2">{{ issue.author }}</span>
                </li>
                <li class="mb-2">
                  <h3 class="body-2">
                    Плановий строк:
                  </h3>
                  <span class="pl-2">{{
                    issue.dueDate ? issue.dueDate : "Не заданий"
                  }}</span>
                </li>
                <li>
                  <h3 class="body-2">
                    Витрачено:
                  </h3>
                  <span class="pl-2">{{
                    (
                      issue.worklog.reduce(
                        (sum, n) => sum + n.timeSpentSeconds,
                        0
                      ) / 3600
                    ).toFixed(2) + " год"
                  }}</span>
                </li>
                <li>
                  <h3 class="body-2">
                    До сплати за базовим тарифом:
                  </h3>
                  <span class="pl-2 display-1">{{
                    (
                      issue.worklog.reduce(
                        (sum, n) => sum + n.payedSeconds,
                        0
                      ) / 3600
                    ).toFixed(2)
                  }}</span><span class="font-weight-medium"> год</span>
                </li>
              </ul>
            </v-col>
            <v-col
              xl="10"
              md="8"
              cols="12"
            >
              <v-tabs
                v-model="tab"
                slider-color="red lighten-2"
              >
                <v-tab class="mr-3">
                  Опис Виконавця
                </v-tab>
                <v-tab class="mx-3">
                  Звернення клієнта
                </v-tab>
                <v-tab class="ml-3">
                  Лог часу
                </v-tab>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <div
                      class="mt-2"
                      style="max-height:250px; overflow-y:auto;"
                      v-html="findWorkingImage"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <div
                      class="mt-2"
                      style="max-height:280px; overflow-y:auto;"
                      v-html="issue.customerDescription"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <div
                      class="mt-2"
                      style="max-height:280px; overflow-y:auto;"
                    >
                      <ul style="list-style: none;">
                        <li
                          v-for="(w, index) in sortedWorklog"
                          :key="index"
                        >
                          <v-chip
                            color="primary"
                            label
                            small
                            outlined
                          >
                            {{ `${w.date} ${w.employee}` }}
                          </v-chip>
                          <span>{{
                            (w.timeSpentSeconds / 3600).toFixed(2) + " год "
                          }}</span>
                          <span class="font-weight-bold">За базовим тарифом:
                            {{
                              (w.payedSeconds / 3600).toFixed(2) + " год "
                            }}</span>
                          <span>{{ w.comment }}</span>
                        </li>
                      </ul>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import JiraIssueLink from "@/components/JiraIssueLink.vue";

export default {
  components: {
    JiraIssueLink,
  },
  props: ["issue"],
  data: () => ({
    tab: "",
  }),
  computed: {
    sortedWorklog() {
      this.issue.worklog.sort((a, b) => {
        if (a.date > b.date) {
          return -1;
        }

        if (a.date < b.date) {
          return 1;
        }

        return 0;
      });
      return this.issue.worklog;
    },
    findWorkingImage() {
      if (this.issue.description.includes("jira-attachment-thumbnail")) {
        return this.issue.description;
      }
      if (this.issue.description.includes("img")) {
        const newDescription = this.issue.description.replace(new RegExp("src=\"", "g"), "src=\"https://atominc.atlassian.net");
        return `${newDescription}`;
      } else {
        return this.issue.description;
      }
    },
  },
};
</script>
<style scoped>
</style>

